import { createReducer } from "redux-create-reducer";
import * as chatActionTypes from "../constants/chatActionTypes";
import chatScreens from "../constants/chatScreens";

const initialState = {
  chatState: "NOT_CHATTING",
  widgetState: "MAXIMIZED",
  chatService: "botEngine",
  rate: "none",
  screen: chatScreens.PRECHAT,
  numberInQueue: 0,
  preForm: {}
};

export default createReducer(initialState, {
  [chatActionTypes.CHAT_STARTED](state) {
    return {
      ...state,
      chatState: "CHATTING",
      chatService: "LiveChat",
      screen: chatScreens.CHAT,
      numberInQueue: 0
    };
  },
  [chatActionTypes.CHANGE_CHAT_SERVICE](state, { payload }) {
    return {
      ...state,
      chatService: payload.chatService
    };
  },
  [chatActionTypes.CHAT_ENDED](state) {
    return {
      ...initialState,
      chatState: "ENDED"
    };
  },
  [chatActionTypes.CHAT_RATED](state, { payload }) {
    return {
      ...state,
      rate: payload.rate || state.rate
    };
  },
  [chatActionTypes.RATE_GOOD](state, { payload }) {
    return {
      ...state,
      rate: "good"
    };
  },
  [chatActionTypes.RATE_BAD](state, { payload }) {
    return {
      ...state,
      rate: "bad"
    };
  },
  [chatActionTypes.CHANGE_CHAT_SCREEN](state, { payload }) {
    return {
      ...state,
      screen: payload.screen
    };
  },
  [chatActionTypes.UPDATE_VISITOR_QUEUE](state, { payload }) {
    return {
      ...state,
      numberInQueue: payload.numberInQueue,
      screen: payload.numberInQueue > 0 ? chatScreens.QUEUE : chatScreens.CHAT
    };
  },
  [chatActionTypes.SAVE_PRE_FORM](state, { payload }) {
    return {
      ...state,
      screen: chatScreens.CHAT,
      preForm: payload
    };
  }
});

export const getChatState = state => state.app.chatState;
export const getWidgetState = state => state.app.widgetState;
export const getChatService = state => state.app.chatService;
export const getRate = state => state.app.rate;
export const getActiveScreen = state => state.app.screen;
export const getNumberInQueue = state => state.app.numberInQueue;
export const getPreForm = state => state.app.preForm;
export const getIsChatting = state =>
  state.app.chatService === "LiveChat" && state.app.chatState === "CHATTING";



// WEBPACK FOOTER //
// ./src/reducers/app.js